jQuery(document).ready(function($){
	/**
	 * Quiz question carousel
	 */
	$('.owl-carousel').owlCarousel({
	    loop: false,
	    margin: 10,
	    nav: true,
	    mouseDrag: false,
      	URLhashListener:true,
	    responsive:{
	        0:{
	            items:1
	        },
	        600:{
	            items:1
	        },
	        1000:{
	            items:1
	        }
	    }
	});
  
    function resetHeight() {
		$('.owl-carousel .owl-item:last-child').css('height','');
        $('.owl-item:last-child .question-container').css({
            'position':'absolute',
            'transform':'translate(0,-50%)'
        })
        $('#quiz-main-container li.item.recommendation h3').css('margin-bottom','20px');
    }

	/**
	 * Set default variables on document ready
	 */
	var total_count = active_index = 0;
	total_count = $('.owl-item').length;
	$('.owl-nav .owl-prev, .owl-nav .owl-next').hide(0);
	$('.owl-item input[type=radio]').prop('checked', false);
	/*
	if( $(window).width() < 670 ){
		console.log( 'Initial: '+$('.owl-item.active').height() );
		$('.owl-carousel .owl-stage-outer').height( $('.owl-item.active').height()+25 );
	}
    */

	/**
	 * Manage current active owl-item index on previous button click
	 */
	$(document).on('click', '.owl-prev', function(ev){
		if(active_index < total_count){
			$('#que-no').text(active_index);
		}

		active_index--;
		var ischecked = $('.owl-item:eq('+active_index+') input[type=radio]').is(':checked');
		if(ischecked){
			$('.owl-nav .owl-prev').show(0);
		}else{
			$('.owl-nav .owl-prev').hide(0);
		}

		if( active_index == 0 ){
			$('.owl-nav .owl-prev').hide(0);
		}
		
      	/*
		if( $(window).width() < 670 ){
			var heightt = $('.owl-item:eq('+active_index+')').height();
			console.log('Prev: '+heightt);
			$('.owl-carousel .owl-stage-outer').height(heightt+25);

			var heightyy = jQuery('.quiz-right-area').height();
			//jQuery('.quiz-left-area').css('height', heightyy+92);
		}
        */
      	
      	/* Reset styling for Results */
      	resetHeight();      	
      
      	/* Reset Call To Actions */
      	$('#cta-buttons').hide();
    });

	/**
	 * Manage current active owl-item index on next button click
	 */
	$(document).on('click', '.owl-next', function(ev){
		active_index++;
		var ischecked = $('.owl-item:eq('+active_index+') input[type=radio]').is(':checked');
		if(ischecked){
			$('.owl-nav .owl-next').show(0);
		}else{
			$('.owl-nav .owl-next').hide(0);
		}

		if( active_index == total_count ){
			$('.owl-nav .owl-next').hide(0);	
		}else{
			if(active_index < total_count-1){
				$('#que-no').text(active_index+1);
			}else{
				$('#quiz-result').html('')
				$('#quiz-submit').show();
			}
		}
		/*
		if( $(window).width() < 670 ){
			var heightt = $('.owl-item:eq('+active_index+')').height();
			console.log('Next: '+heightt);
			$('.owl-stage-outer').height(heightt+25);

			var heightyy = jQuery('.quiz-right-area').height();
			//jQuery('.quiz-left-area').css('height', heightyy+92);
		}
        */
	});

	/**
	 * Check radio button when click on option image
	 */
	$(document).on('click', '.quiz-option-images .radio-picture', function(){
      	
		if( $(this).find('img').length > 0 ){
          	$('#mobile-quiz-image-text').text( $(this).next('.quiz-image-text').text() );
			$('.quiz-option-images .radio-picture').removeClass('active');
			$(this).addClass('active');
			$(this).prev('input[type=radio]').prop('checked', true).trigger('change');
		}
	});

	/**
	 * Show hide next/prev button on option choosen
	 */
	$('.select-quiz-options input[type=radio]').on('change', function(){
		//alert(this.value);
		if( this.value ){
			if(active_index == 0){
				$('.owl-nav .owl-next').show(0);
				$('.owl-nav .owl-prev').hide(0);
			}else if(active_index == total_count){
				$('.owl-nav .owl-next').hide(0);
				$('.owl-nav .owl-prev').show(0);
			}else{
				$('.owl-nav .owl-next').show(0);
			}
		}else{
			//do nothing
		}
	});

	/**
	 * Submit quiz for result
	 */
	$(document).on('click', '#quiz-submit', function(){
		var quiz_ans = [];
		$('.options-quiz-question').each(function(){
			var temp_quiz_ans = {};

			var ans_input = $(this).find('.select-quiz-options input[type=radio]:checked');

			if( ans_input.length > 0 ){
				var ans_input_val = ans_input.val();
				quiz_ans.push(ans_input_val);
			}
		}).promise().done(function(){
			/**
			* Read text File  
			*/
			$.ajax({
				type: 'GET',
              	url: 'https://cdn.shopify.com/s/files/1/0482/3981/files/result.txt?v=1670457523',
				dataType: 'text',
				success: function(data){
					var data_obj = JSON.parse(data);
					$.each(data_obj, function(key,value) {
						if( (value['que1'] == quiz_ans[0]) && (value['que2'] == quiz_ans[1]) && (value['que3'] == quiz_ans[2]) ){
							$('#quiz-submit').hide(0);
							$('#quiz-result').html('<p>'+value['result']+'</p>');
							/*
							if( $(window).width() < 670 ){
								console.log($('#quiz-result').height()+100);
								$('.owl-stage-outer').height( $('#quiz-result').height()+100 );
							}
                            */
              				if( $(window).width() < 740 ) {
                              $('.owl-carousel .owl-item:last-child').css('height','auto');
                              $('.owl-item:last-child .question-container').css({
                                'position':'static',
                                'transform':'translate(0,0)'
                              })
                              $('#quiz-main-container li.item.recommendation h3').css('margin-bottom','20px');
        					}
                          
                          	$ctaButtons = $('#cta-buttons').show();
      						containerHeight = $ctaButtons.parents('.question-container').height();
      						$ctaButtons.parents('.owl-item.active').height( containerHeight );
                            console.log('end line');
						}
					});
				}
			});
		});
	});
		
	// Call to action buttons (at the end)
	// 1) Shop Now
	// 2) Restart
	// 3) Fitting Room
	$(document).on('click', 'input', function( e ) {
    	// 1) Shop Now
        switch ( e.target.id ) {
			
            case "quiz-cta-shopnow":		location.href="/collections/bras";
                                      		break;
            
          	case "quiz-cta-restart":		$('#cta-buttons').hide("fast",function(){
            									$('.owl-item input[type=radio]').prop('checked', false);		// Reset Radio Boxes (questions)
                                                active_index = 0;												// Reset Active Index
                                                $('.owl-carousel').data('owlCarousel').to(0);					// Take user to first slide
                                                $('.owl-nav .owl-prev, .owl-nav .owl-next').hide(0);			// Hide all arrows
                                                $('.quiz-option-images .radio-picture').removeClass('active');	// Remove all "active" status on the images
                                                $('#mobile-quiz-image-text').text('');							// Delete text inside
                                                $('#que-no').text('1');											// Reset que no
                                                resetHeight();													// Reset Height
            								});
            								break;
            
            case "quiz-fitting-room":	location.href="/pages/your-fitting-room";
            								break;
        }
    });

});

jQuery(window).load(function($){
	var heightyy = jQuery('.quiz-right-area').height();
	//jQuery('.quiz-left-area').css('height', heightyy+91);
});